import { Info } from "lucide-react";

const DEF = "Demo funksiyanın iş prinsipini göstərir. Yekun dizayn layihəyə uyğun fərdi hazırlanır.";

export const Disclaimer = ({ text = DEF, light = false }) => (
  <div
    className={`flex gap-2 items-start text-xs rounded-xl p-3 border ${light ? "text-[#8a6a2f] bg-[#FBF6EC] border-[#D6AD62]/40" : "text-[#F3D592]/90 bg-[#D6AD62]/[0.07] border-[#D6AD62]/25"}`}
    data-testid="demo-disclaimer"
  >
    <Info className="h-4 w-4 shrink-0 mt-0.5" />
    <span>{text}</span>
  </div>
);
